"use strict";

module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ext/global-this/is-implemented.js
 ** module id = 106
 ** module chunks = 0
 **/